import { render, staticRenderFns } from "./AddToCartNotification.vue?vue&type=template&id=36b6c878&scoped=true&"
import script from "./AddToCartNotification.vue?vue&type=script&lang=js&"
export * from "./AddToCartNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartNotification.vue?vue&type=style&index=0&id=36b6c878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6c878",
  null
  
)

export default component.exports